import { useCallback, useEffect, useRef, useState } from 'react';

import { get } from 'helpers/api';

import type { Import } from './types';

type Timeout = ReturnType<typeof setTimeout> | null;
type Imports = Import[] | undefined;

// TODO: Should really just be using RTKQuery...
// TODO: Remove the `poll` prop, refactor usage so this is rendered in the table component (and so polls if mounted)
export function usePollingImports(groupId, poll = true, interval = 5000): [Imports, (newImport: Import) => void] {
  const [imports, setImports] = useState<Imports>();
  const timeoutRef = useRef<Timeout>(null);

  useEffect(() => {
    async function fetchImports() {
      poll && setImports(await get(`/dromo/imports?group_id=${groupId}`));
      if (interval) {
        timeoutRef.current = setTimeout(fetchImports, interval);
      }
    }

    fetchImports();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [groupId, poll, interval]);

  const addImport = useCallback((newImport: Import) => {
    setImports(_imports => [newImport, ...(_imports || [])]);
  }, []);

  return [imports, addImport];
}
